// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"skins-iconAfter-buttonIcon-bd3ae2c1"};